/** Newest PAF first (issue date, then id). */
export function sortPrescriptionsByDateDesc(items) {
  if (!Array.isArray(items) || items.length === 0) return [];
  return [...items].sort((a, b) => {
    const ta = new Date(a.pfa_issued || 0).getTime();
    const tb = new Date(b.pfa_issued || 0).getTime();
    if (tb !== ta) return tb - ta;
    return (b.id || 0) - (a.id || 0);
  });
}

/** Prior PAFs for a patient, excluding the prescription currently on screen. */
export function getHistoryPrescriptionsExcept(prescriptions, currentPrescriptionId) {
  const sorted = sortPrescriptionsByDateDesc(prescriptions);
  if (currentPrescriptionId == null) return sorted.slice(1);
  return sorted.filter((p) => p.id !== currentPrescriptionId);
}
